<template>
  <div class="count-cate">
    <slot name="body"></slot>
  </div>
</template>

<script>
export default{
    name: 'CountCate',
    data() {
        return {
           
        }
    },
}
</script>

<style scoped>
.count-cate {
    box-shadow: 0 15px 30px rgba(0,0,0,.3);
    width: 2.5rem;
    height: 3rem;
    display: flex;
    flex-direction: column;
    justify-content:space-evenly;
    align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/commonReform/CountCate.vue